/*eslint backbone/no-constructor:0 */
define('glu/grid/column/columnHeaderDragger',['require','../../itemView','../../$document','../../$','../../util','jui/sortable'],function(require) {
    'use strict';

    var ItemView = require('../../itemView'),
        $document = require('../../$document'),
        $ = require('../../$'),
        util = require('../../util');

    require('jui/sortable');

    return ItemView.extend({
        template: function() {
            return '&nbsp;';
        },

        className: 'grid-column-order-marker',
        activeClassName: 'grid-column-order-active',

        attributes: {
            'role': 'presentation'
        },

        ui: {
            resizeMarker: '.draggable'
        },

        active: true,
        juihelper: 'clone',
        juiaxis: 'x',
        juirevert: false,
        order: null,

        juiOpts: ['juiappendTo', 'juiaxis', 'juicancel', 'juiconnectWith', 'juicontainment', 'juicursor',
            'juicursorAt', 'juidelay', 'juidisabled', 'juidistance', 'juidropOnEmpty', 'juiforceHelperSize',
            'juiforcePlaceholderSize', 'juigrid', 'juihandle', 'juihelper', 'juiitems', 'juiopacity', 'juiplaceholder',
            'juirevert', 'juiscroll', 'juiscrollSensitivity', 'juiscrollSpeed', 'juitolerance', 'juizIndex', 'juicancel',
            'juidestroy', 'juidisable', 'juienable', 'juiinstance', 'juioption', 'juirefresh', 'juirefreshPositions',
            'juiserialize', 'juitoArray', 'juiwidget', 'juiactivate', 'juibeforeStop', 'juichange', 'juicreate',
            'juideactivate', 'juiout', 'juiover', 'juireceive', 'juiremove', 'juisort', 'juistart', 'juistop', 'juiupdate'
        ],

        initialize: function() {
            this.th = this.options.$th[0];
            this.$th = this.options.$th;
            this.data = this.options.data;
            this.juihandle = '.draggable';
            this.juistop = this.handleStop.bind(this);
        },

        handleDragStart: function(e) {
            // Only allow drag start on left mouse button (1)
            if (e.which !== 1) {
                return;
            }

            this.$th.addClass('dragging');

            if (this.active) {
                this.$parentRow = this.$th.parents('tr');
                this.handle = this.ui.resizeMarker.selector;
                //extend instance properties with jui specific options.
                // this is done to avoid unintentionally overwriting backbone specific features
                var temp = util.pick(util.extend(this, this.options), this.juiOpts),
                    opts = {};

                util.each(temp, function(value, key) {
                    opts[key.replace('jui', '')] = value;
                });

                this.$parentRow.addClass(this.activeClassName);
                this.$parentRow.sortable(opts);
                this.order = util.indexOf(this.$parentRow.children(), this.th);
            }
        },

        handleStop: function() {
            this.$th.removeClass('dragging');
            this.active = false;
            var newOrder = util.indexOf(this.$parentRow.children(), this.th),
                newOrderAdjusted = this.adjustedIndex(newOrder),
                thCollection = this.data.collection;
            if (newOrder > -1 && this.order !== newOrder) {
                var model = this.columnAtVisibleIndex(this.order);
                thCollection.remove(model, {
                    silent: true
                });
                thCollection.add(model, {
                    at: newOrderAdjusted
                });
                this.trigger('reorder', this);
                this.data.trigger('change:reorder', this);
            }
        },

        columnAtVisibleIndex: function(visibleIndex) {
            return this.data.collection.at(this.adjustedIndex(visibleIndex));
        },

        adjustedIndex: function(visibleIndex) {
            //TODO: Rewrite algorithm when not tired.

            var index = 0;
            var movesRemaining = visibleIndex + 1;

            while (movesRemaining > 0) {
                var column = this.data.collection.at(index);
                while (column && this.isColumnHidden(column)) {
                    index++;
                    column = this.data.collection.at(index);
                }
                index++;
                movesRemaining--;
            }

            return index - 1;
        },

        isColumnVisible: function(column) {
            if (column.has('condition')) {
                if (util.isFunction(column.get('condition'))) {
                    return column.get('condition')(); // REVIEW: Unclear what if any arguments should be passed here.
                } else if (util.isBoolean(column.get('condition'))) {
                    return column.get('condition');
                } else {
                    return true;
                }
            }
            return true;
        },

        isColumnHidden: function(column) {
            return !this.isColumnVisible(column);
        }
    });
});

